
import React, { useState } from "react";
import "./CementDetails.css";

const CementDetails = () => {
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  return (
    <div className="ldh-cemt-section">
      <h2>Cement</h2>

      {/* What is Cement */}
      <div className="ldh-cemt-accordion">
        <button onClick={() => toggleSection("what")}>
          What is Cement?
          <span>{openSection === "what" ? "−" : "+"}</span>
        </button>

        {openSection === "what" && (
          <div className="ldh-cemt-content">
            <p>
              Cement is a binding material that, when mixed with water, sets
              and hardens to bind sand and aggregates in construction.
            </p>
          </div>
        )}
      </div>

      {/* Cement Grades & Uses */}
      <div className="ldh-cemt-accordion">
        <button onClick={() => toggleSection("grades")}>
          Cement Grades & Uses
          <span>{openSection === "grades" ? "−" : "+"}</span>
        </button>

        {openSection === "grades" && (
          <div className="ldh-cemt-content">
            <p>
              <strong>OPC 43:</strong> General construction, masonry,
              plastering and RCC work.
            </p>

            <p>
              <strong>OPC 53:</strong> RCC, precast, bridges and applications
              requiring higher early strength.
            </p>

            <p>
              <strong>PPC:</strong> Buildings, foundations, plastering and
              general construction, with good durability.
            </p>

            <p>
              <strong>PSC:</strong> Infrastructure, foundations, bridges and
              suitable aggressive environments.
            </p>
          </div>
        )}
      </div>

      {/* How to Choose */}
      <div className="ldh-cemt-accordion">
        <button onClick={() => toggleSection("choose")}>
          How to Choose?
          <span>{openSection === "choose" ? "−" : "+"}</span>
        </button>

        {openSection === "choose" && (
          <div className="ldh-cemt-content">
            <p>
              Choose cement based on construction type, required strength,
              exposure conditions and project specifications.
            </p>
          </div>
        )}
      </div>

      {/* FAQ 1 */}
      <div className="ldh-cemt-accordion">
        <button onClick={() => toggleSection("faq1")}>
          How can I get the current cement rates?
          <span>{openSection === "faq1" ? "−" : "+"}</span>
        </button>

        {openSection === "faq1" && (
          <div className="ldh-cemt-content">
            <p>
              We do not display predefined cement rates because prices can
              change based on current market conditions, brand, grade,
              quantity, location, and delivery requirements. Please submit a
              quote request (<b className="text-primary"> Request today's rate </b>) to get the latest rates.
            </p>
          </div>
        )}
      </div>



      {/* FAQ 2 */}
      <div className="ldh-cemt-accordion">
        <button onClick={() => toggleSection("faq3")}>
          Are the rates fixed?
          <span>{openSection === "faq3" ? "−" : "+"}</span>
        </button>

        {openSection === "faq3" && (
          <div className="ldh-cemt-content">
            <p>
              No. Cement rates are subject to change based on market
              conditions, brand, grade, quantity, location, and delivery
              requirements. The final rate will be confirmed at the time of
              quotation.
            </p>
          </div>
        )}
      </div>

      {/* FAQ 3 */}
      <div className="ldh-cemt-accordion">
        <button onClick={() => toggleSection("faq5")}>
          Can I request rates for multiple brands and grades?
          <span>{openSection === "faq5" ? "−" : "+"}</span>
        </button>

        {openSection === "faq5" && (
          <div className="ldh-cemt-content">
            <p>
              Yes. You can mention your preferred cement brand or grades in
              the quote request (<b className="text-primary"> Request today's rate </b>). Our team will provide the applicable rates
              based on availability and current pricing.
            </p>
          </div>
        )}
      </div>

      {/* FAQ 4 */}
      <div className="ldh-cemt-accordion">
        <button onClick={() => toggleSection("faq6")}>
          How are delivery charges and times determined?
          <span>{openSection === "faq6" ? "−" : "+"}</span>
        </button>

        {openSection === "faq6" && (
          <div className="ldh-cemt-content">
            <p>
              Delivery charges and estimated delivery times may vary depending
              on the delivery location, quantity, stock availability, and
              logistics requirements. These details can be discussed as part
              of your quote.
            </p>
          </div>
        )}
      </div>

      {/* FAQ 5 */}
      <div className="ldh-cemt-accordion">
        <button onClick={() => toggleSection("faq7")}>
          Can I request a quote for loose cement requirements?
          <span>{openSection === "faq7" ? "−" : "+"}</span>
        </button>

        {openSection === "faq7" && (
          <div className="ldh-cemt-content">
            <p>
              Yes. You can submit loose cement requirements through the quote
              request (<b className="text-primary"> Request today's rate </b>) page. Please provide the required quantity, cement
              grade, location, and other relevant details so we can prepare
              an appropriate quotation.
            </p>
          </div>
        )}
      </div>

      {/* FAQ 6 */}
      <div className="ldh-cemt-accordion">
        <button onClick={() => toggleSection("faq8")}>
          What information should I provide for a quote?
          <span>{openSection === "faq8" ? "−" : "+"}</span>
        </button>

        {openSection === "faq8" && (
          <div className="ldh-cemt-content">
            <p>
              Please provide details such as cement grade, preferred brand,
              required quantity, delivery location, and any specific project
              or delivery requirements. This helps us provide a more accurate
              quotation.
            </p>
          </div>
        )}
      </div>
      {/* FAQ 7 */}
      <div className="ldh-cemt-accordion">
        <button onClick={() => toggleSection("faq12")}>
          Who can I contact for assistance?
          <span>{openSection === "faq12" ? "−" : "+"}</span>
        </button>

        {openSection === "faq12" && (
          <div className="ldh-cemt-content">
            <p>
              For assistance with your cement requirements or quotation,
              please contact our customer support team at <b> Phone: 9876980108, Email: support@altrange.com </b>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CementDetails;

